import { fontFamilyFor, RADIUS } from "../../theme";

export const Style = {
  button: (isArabic) => ({
    fontSize: "14px",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    fontWeight: 700,
    textTransform: "capitalize",
    borderRadius: RADIUS.pill,
  }),
};
